"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenesysLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.GenesysLogo = styled_components_1.default.img `
  height: 25px;
`;
//# sourceMappingURL=genesys-logo.js.map